import React from 'react';
import propTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import s from './styles.module.scss';

const UserLicense = ({ t }) => (
  <div className={s.content}>
    <div>
      <div>{t('userLicenceAgreement.documentTitleOne')}</div>
      <div>{t('userLicenceAgreement.documentTitleTwo')}</div>
    </div>
    <div>
      <div>{t('userLicenceAgreement.userNote')}</div>
      <div>{t('userLicenceAgreement.contractDescription')}</div>
    </div>
    <div>{t('userLicenceAgreement.termsDesc')}</div>
    <ol>
      <li>
        <span>{t('userLicenceAgreement.firstTermTitle')}</span>{' '}
        {t('userLicenceAgreement.firstTerm')}
      </li>
      <li>
        <span>{t('userLicenceAgreement.secondTermTitle')}</span>{' '}
        {t('userLicenceAgreement.secondTerm')}
      </li>
      <li>
        <span>{t('userLicenceAgreement.thirdTermTitle')}</span>{' '}
        {t('userLicenceAgreement.thirdTerm')}
      </li>
      <li>
        <span>{t('userLicenceAgreement.fourthTermTitle')}</span>{' '}
        {t('userLicenceAgreement.fourthTerm')}
      </li>
      <li>
        <span>{t('userLicenceAgreement.fifthTermTitle')}</span>{' '}
        {t('userLicenceAgreement.fifthTerm')}
      </li>
      <li>
        <span>{t('userLicenceAgreement.sixthTermTitle')}</span>{' '}
        {t('userLicenceAgreement.sixthTerm')}
      </li>
      <li>
        <span>{t('userLicenceAgreement.seventhTermTitle')}</span>{' '}
        {t('userLicenceAgreement.seventhTerm')}
      </li>
      <li>
        <span>{t('userLicenceAgreement.eighthTermTitle')}</span>{' '}
        {t('userLicenceAgreement.eighthTerm')}
      </li>
      <li>
        <span>{t('userLicenceAgreement.ninthTermTitle')}</span>{' '}
        {t('userLicenceAgreement.ninthTerm')}
      </li>
    </ol>
    <div>
      <div>{t('userLicenceAgreement.companyTitle')}</div>
      <div>{t('userLicenceAgreement.companyAddress')}</div>
    </div>
  </div>
);

UserLicense.propTypes = {
  t: propTypes.func.isRequired,
};
export default withTranslation()(UserLicense);
